import React, { useState } from 'react'

const JsonCompare = ({ currentJsonStr, newJsonStr }) => {
  const [hoveredKey, setHoveredKey] = useState(null)

  const safeParse = (str) => {
    try {
      const parsed = JSON.parse(str || '{}')
      return parsed && typeof parsed === 'object' ? parsed : {}
    } catch {
      console.error('Invalid JSON:', str)
      return {}
    }
  }

  const currentObj = safeParse(currentJsonStr)
  const newObj = safeParse(newJsonStr)

  const allKeys = Array.from(
    new Set([...Object.keys(currentObj), ...Object.keys(newObj)]),
  )

  const isNullLike = (v) => v === null || v === undefined || v === 'null'

  const rowStyle = (highlight, key) => ({
    backgroundColor:
      hoveredKey === key
        ? '#d6eaff' // màu khi hover đồng bộ 2 bên
        : highlight
          ? '#fff3cd'
          : 'transparent',
    padding: '4px 0',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
  })

  return (
    <div style={{ display: 'flex', fontSize: 14 }}>
      {/* Giá trị hiện tại */}
      <div
        style={{
          width: '50%',
          paddingRight: 10,
          paddingLeft: 50,
          borderRight: '1px solid #f0f0f0',
          textIndent: 10,
        }}
      >
        <center>
          <h4>Giá trị hiện tại</h4>
        </center>
        {currentJsonStr &&
          currentJsonStr !== 'null' &&
          allKeys.map((key) => {
            const value = currentObj[key]
            const newValue = newObj[key]
            const isDifferent = value !== newValue
            const isOneNull = isNullLike(value) !== isNullLike(newValue)
            const highlight = isDifferent || isOneNull

            return (
              <div
                key={key}
                style={rowStyle(highlight, key)}
                onMouseEnter={() => setHoveredKey(key)}
                onMouseLeave={() => setHoveredKey(null)}
              >
                <strong>{key}:</strong>{' '}
                {!isNullLike(value) ? String(value) : <i>null</i>}
              </div>
            )
          })}
      </div>

      {/* Giá trị mới */}
      <div
        style={{
          width: '50%',
          paddingLeft: 10,
          paddingRight: 60,
          textIndent: 10,
        }}
      >
        <center>
          <h4>Giá trị mới</h4>
        </center>
        {newObj &&
          newObj !== 'null' &&
          allKeys.map((key) => {
            const value = currentObj[key]
            const newValue = newObj[key]
            const isDifferent = value !== newValue
            const isOneNull = isNullLike(value) !== isNullLike(newValue)
            const highlight = isDifferent || isOneNull

            return (
              <div
                key={key}
                style={rowStyle(highlight, key)}
                onMouseEnter={() => setHoveredKey(key)}
                onMouseLeave={() => setHoveredKey(null)}
              >
                <strong>{key}:</strong>{' '}
                {!isNullLike(newValue) ? String(newValue) : <i>null</i>}
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default JsonCompare
